import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import Routes from "../components/Routes";

function LogoutPage() {
  return (
    <Box width={600} style={{ margin: "100px auto" }}>
      <p>You have successfully been logged out.</p>
      <p>
        Go back to the <Link to={Routes.home}>Home Page</Link>
      </p>
    </Box>
  );
}

export default LogoutPage;
